
import { computed, defineComponent, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { getCurrent, postPostComment, removePostComment, getMoreComment } from '@/api'
import { useToast } from 'vue-toastification'
import { UserInfo } from '@/store'
import { RecentCarousel } from '@/components/carousel.vue'
import Button from '@/components/btn.vue'
import { useStore } from 'vuex'
import bus from '@/plugins/bus'
export interface Comment {
  _v?: number;
  _id: string;
  comment: string;
  createdAt: string;
  id: string;
  post: string;
  user: UserInfo;
}
export interface PageContent extends RecentCarousel {
  comments: Comment[];
}
export default defineComponent({
  components: {
    Button
  },
  async setup () {
    const router = useRouter()
    const store = useStore()
    const toast = useToast()
    const commentPage = ref(2)
    const moreComment = ref(true)
    const comment = ref('')
    const pageContent = reactive({ data: {} as PageContent })
    const openLogin = () => {
      bus.emit('Login-open')
    }
    const deletePost = async (id: string) => {
      try {
        const res = await removePostComment(id)
        if (res.status === 204) {
          pageContent.data.comments = pageContent.data.comments.filter((item: Comment) => {
            return item.id !== id
          })
        }
        toast.success('Comment deleted')
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    const getPage = async (id: string) => {
      try {
        store.dispatch('loading')
        const res = await getCurrent(
          id
        )
        if (res.status === 200) {
          pageContent.data = res.data.data
          setTimeout(() => store.dispatch('loading'), 2000)
        }
      } catch (error) {
        toast.error(error.response.data.message)
        setTimeout(() => store.dispatch('loading'), 2000)
      }
    }
    const sendComment = async () => {
      try {
        const res = await postPostComment(router.currentRoute.value.params.id as string, comment.value)
        if (res.status === 201) {
          toast.success('comment sent successfully')
          getPage(router.currentRoute.value.params.id as string)
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    const getComments = async () => {
      try {
        if (!moreComment.value) return
        const res = await getMoreComment(router.currentRoute.value.params.id as string, commentPage.value)
        if (res.status === 200) {
          if (res.data.data.length === 0) moreComment.value = false
          pageContent.data.comments = [...pageContent.data.comments, ...res.data.data]
          commentPage.value++
        }
      } catch (error) {
        toast.error(error.response.data.message)
      }
    }
    watch(() => router.currentRoute.value.params.id, async (newVal) => {
      if (!newVal) return
      getPage(newVal as string)
    })
    try {
      const res = await getCurrent(
        router.currentRoute.value.params.id as string
      )
      if (res.status === 200) {
        pageContent.data = res.data.data
      }
    } catch (error) {
      toast.error(error.response.data.message)
    }
    const user = computed(() => {
      return store.getters.getUser
    })
    return {
      pageContent,
      comment,
      user,
      openLogin,
      sendComment,
      deletePost,
      getComments,
      moreComment
    }
  }
})
